export const primaryColors = {
  zemplerBlue: '#80D9FF',
  darkBlue: '#001921',
  white: '#FFFFFF',
  neutral: '#F6F5F3',
  lime: '#CDFC69',
  darkBlueOpacity: 'rgba(0, 25, 33, 0.65)',
} as const;
